export default __webpack_public_path__ + "static/media/product6.561b1621.png";